import ScreenContainer from '../../display/ui/ScreenContainer';
import TexturedPanel from '../../display/ui/TexturedPanel';
import { FONT_TITLE } from '../../constants/AppConstants';
import { GetBaseUrl } from '../../constants/AppUrls';
import Hud from '../hud/Hud';
import { GetDefaultButtonCostume } from '../hud/HudConstants';

export default class ScreenOverlayCertificate extends ScreenContainer {
  constructor(game) {
    super(game, { modal: true, title: 'congratulations', background: 'background_alt_overlay' });

    // dispatch when user closes screen, will auto hide itself
    this.onScreenClosed = new Phaser.Signal();

    this.loadImage('assets/locale/' + this.game.language + '/certificate_thumbnail.png');
  }

  /*
  =======================================================================================================
    LOAD IMAGE
  =======================================================================================================
  */

  loadImage(imageurl) {
    this.imageurl = imageurl;

    // reset loader and load image
    this.game.load.baseURL = '';
    this.game.load.crossOrigin = 'anonymous';
    this.game.load.image(imageurl, imageurl, true);
    this.game.load.onFileComplete.add(this.handleImageLoaded, this);
    this.game.load.start();
  }

  handleImageLoaded() {
    // kill listener
    this.game.load.onFileComplete.remove(this.handleImageLoaded, this);

    this.certificateContainer = this.game.make.group();

    // clone, tint and make shadow
    this.certificateShadow = this.game.make.image(0, 5, this.imageurl);
    this.certificateShadow.tint = 0x000000;
    this.certificateShadow.alpha = 0.25;
    this.certificateShadow.y = 5;
    this.certificateContainer.add(this.certificateShadow);

    // make certificate
    this.certificate = this.game.make.image(0, 0, this.imageurl);
    this.certificateContainer.add(this.certificate);

    // scale cert to fit :)
    this.certificateContainer.scale.set(
      Math.min(1, Math.min(393 / this.certificate.width, 287 / this.certificate.height))
    );

    const certWidth = this.certificate.width * this.certificateContainer.scale.x;
    const certHeight = this.certificate.height * this.certificateContainer.scale.y;

    // position and add certificate
    this.certificateContainer.x = this.game.defaultWidth * 0.5 - certWidth * 0.5;
    this.certificateContainer.y = this.game.defaultHeight * 0.45 - certHeight * 0.5;

    // create panel
    this.messageUpper = this.game.make.text(0, 0, this.game.copy.getCopy('certificate_1'), {
      font: '35px ' + this.game.titleFontStyle,
      fill: '#0090C1',
    });
    this.messageLower = this.game.make.text(0, 0, this.game.copy.getCopy('certificate_2'), {
      font: '45px ' + this.game.titleFontStyle,
      fill: '#0090C1',
    });

    this.panel = new TexturedPanel(this.game, {
      width: Math.max(this.messageLower.width, this.messageUpper.width) + 150,
      height: this.messageLower.height + this.messageUpper.height + 60,
      corner: 30,
    });

    this.messageUpper.x = this.panel.width * 0.5 - this.messageUpper.width * 0.5;
    this.messageLower.x = this.panel.width * 0.5 - this.messageLower.width * 0.5;
    this.messageUpper.y = 30;
    this.messageLower.y = this.messageUpper.y + this.messageUpper.height;

    this.panel.x = this.certificateContainer.x + certWidth * 0.5 - this.panel.width * 0.5;
    this.panel.y = this.certificateContainer.y + certHeight - 10;

    this.panel.add(this.messageUpper);
    this.panel.add(this.messageLower);
    this.add(this.panel);
    this.add(this.certificateContainer);

    this.btn = Hud.CreateHudButton(GetDefaultButtonCostume('print'), this.game);
    this.btn.onInputDown.add(this.handleDownloadCertificate, this);
    this.btn.x = this.panel.x + this.panel.width - this.btn.width * 0.5;
    this.btn.y = this.panel.y + this.panel.height - this.btn.height * 0.5;
    this.add(this.btn);

    this.btnArrow = Hud.CreateHudButton(GetDefaultButtonCostume('rightarrow_med'), this.game);
    this.btnArrow.onInputDown.add(this.handleButtonInput, this);
    this.btnArrow.x = this.panel.x + this.panel.width - this.btnArrow.width * 0.5;
    this.btnArrow.y = this.panel.y + this.panel.height - this.btnArrow.height * 0.5;
    this.add(this.btnArrow);
    this.btnArrow.visible = false;

    if (this.game.device.iOS) {
      this.updateButton();
    }
  }

  handleDownloadCertificate() {
    // try and download image, if this fails it will open in new window
    let link = document.createElement('a');
    link.setAttribute(
      'href',
      GetBaseUrl('assets/locale/' + this.game.language + '/certificate.jpg')
    );
    link.setAttribute('download', 'certificate.jpg');
    link.setAttribute('target', '_blank');
    link.style.display = 'none';
    link.onclick = this.updateButton();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  updateButton() {
    this.btn.visible = false;
    this.btnArrow.visible = true;
  }

  handleButtonInput() {
    this.visible = false;
    this.onScreenClosed.dispatch();
  }

  /*
  =======================================================================================================
    CLOSE
  =======================================================================================================
  */

  closePanel() {
    this.visible = false;
    this.onScreenClosed.dispatch(this);
  }

  /*
  =======================================================================================================
    DESTROY
  =======================================================================================================
  */

  destroy() {
    // destroy the image
    if (this.image) {
      this.image.destroy(true, this.imageurl != false);
      this.image = null;
    }

    // remove the load listener ( just in case )
    this.game.load.onFileComplete.remove(this.handleImageLoaded, this);

    // destroy other assets

    // Commeted this out casuing an error after the
    // certificate overlay on world map
    // this.contentPanel.destroy(true);
    // this.contentPanel = null;

    super.destroy(true);
  }
}



// WEBPACK FOOTER //
// ./js/app/ui/overlays/ScreenOverlayCertificate.js